module.exports = __webpack_public_path__ + "static/media/SmallCabinet_Before.774954cc.jpg";